{
  "about.blocks": "Moderatutako zerbitzariak",
  "about.contact": "Kontaktua:",
  "about.default_locale": "Lehenetsia",
  "about.domain_blocks.no_reason_available": "Arrazoia ez dago eskuragarri",
  "about.domain_blocks.preamble": "Mastodonek orokorrean aukera ematen dizu fedibertsoko beste zerbitzarietako erabiltzaileen edukia ikusi eta haiekin komunikatzeko. Zerbitzari zehatz honi ezarritako salbuespenak hauek dira.",
  "about.domain_blocks.silenced.explanation": "Orokorrean ez duzu zerbitzari honetako profil eta edukirik ikusiko. Profilak jarraitzen badituzu edo edukia esplizituki bilatzen baduzu bai.",
  "about.domain_blocks.silenced.title": "Mugatua",
  "about.domain_blocks.suspended.explanation": "Ez da zerbitzari honetako daturik prozesatuko, gordeko, edo partekatuko, zerbitzari honetako erabiltzaileekin komunikatzea ezinezkoa eginez.",
  "about.domain_blocks.suspended.title": "Kanporatua",
  "about.language_label": "Hizkuntza",
  "about.not_available": "Zerbitzari honek ez du informazio hau eskuragarri jarri.",
  "about.powered_by": "{mastodon} erabiltzen duen sare sozial deszentralizatua",
  "about.rules": "Zerbitzariaren arauak",
  "account.account_note_header": "Ohar pertsonala",
  "account.add_or_remove_from_list": "Gehitu edo kendu zerrendetatik",
  "account.badges.bot": "Bot-a",
  "account.badges.group": "Taldea",
  "account.block": "Blokeatu @{name}",
  "account.block_domain": "Blokeatu {domain} domeinua",
  "account.block_short": "Blokeatu",
  "account.blocked": "Blokeatuta",
  "account.cancel_follow_request": "Baztertu jarraitzeko eskaera",
  "account.copy": "Kopiatu profilerako esteka",
  "account.direct": "Aipatu pribatuki @{name}",
  "account.disable_notifications": "Utzi jakinarazteari @{name} erabiltzaileak argitaratzean",
  "account.edit_profile": "Editatu profila",
  "account.edit_profile_short": "Editatu",
  "account.enable_notifications": "Jakinarazi @{name} erabiltzaileak argitaratzean",
  "account.endorse": "Nabarmendu profilean",
  "account.familiar_followers_many": "Jarraitzaileak: {name1}, {name2} eta beste {othersCount, plural, one {ezagun bat} other {# ezagun}}",
  "account.familiar_followers_one": "{name1}-k jarraitzen du",
  "account.familiar_followers_two": "{name1}-k eta {name2}-k jarraitzen dute",
  "account.featured": "Gailenak",
  "account.featured.accounts": "Profilak",
  "account.follow": "Jarraitu",
  "account.follow_back": "Jarraitu bueltan",
  "account.follow_back_short": "Jarraitu bueltan",
  "account.follow_request": "Eskatu jarraitzeko",
  "account.follow_request_cancel": "Ezeztatu eskaera",
  "account.follow_request_cancel_short": "Ezeztatu",
  "account.follow_request_short": "Eskaera",
  "account.followers": "Jarraitzaileak",
  "account.followers.empty": "Ez du inork erabiltzaile hau jarraitzen oraindik.",
  "account.followers_counter": "{count, plural, one {{counter} jarraitzaile} other {{counter} jarraitzaile}}",
  "account.followers_you_know_counter": "{counter} ezagutzen dituzu",
  "account.following": "Jarraitzen",
  "account.following_counter": "{count, plural, one {{counter} jarraitzen} other {{counter} jarraitzen}}",
  "account.follows.empty": "Erabiltzaile honek ez du inor jarraitzen oraindik.",
  "account.follows_you": "Jarraitzen zaitu",
  "account.go_to_profile": "Joan profilera",
  "account.hide_reblogs": "Ezkutatu @{name} erabiltzailearen bultzadak",
  "account.in_memoriam": "Oroimenezkoa.",
  "account.joined_short": "Elkartuta",
  "account.languages": "Aldatu harpidetutako hizkuntzak",
  "account.link_verified_on": "Esteka honen jabetzaren egiaztaketa data: {date}",
  "account.locked_info": "Kontu honen pribatutasun egoera blokeatuta gisa ezarri da. Jabeak eskuz erabakitzen du nork jarraitu diezaioken.",
  "account.media": "Multimedia",
  "account.mention": "Aipatu @{name}",
  "account.moved_to": "{name} erabiltzaileak adierazi du bere kontu berria hau dela:",
  "account.mute": "Mututu @{name}",
  "account.mute_notifications_short": "Mututu jakinarazpenak",
  "account.mute_short": "Mututu",
  "account.muted": "Mutututa",
  "account.mutual": "Elkar jarraitzen duzue",
  "account.no_bio": "Ez da deskribapenik eman.",
  "account.open_original_page": "Ireki jatorrizko orria",
  "account.posts": "Bidalketa",
  "account.remove_from_followers": "Kendu {name} zure jarraitzaileengandik",
  "account.report": "Salatu @{name}",
  "account.requested_follow": "{name}-(e)k zu jarraitzeko eskaera egin du",
  "account.share": "Partekatu @{name} erabiltzailearen profila",
  "account.show_reblogs": "Erakutsi @{name} erabiltzailearen bultzadak",
  "account.statuses_counter": "{count, plural, one {{counter} bidalketa} other {{counter} bidalketa}}",
  "account.unblock": "Desblokeatu @{name}",
  "account.unblock_domain": "Berriz erakutsi {domain}",
  "account.unblock_domain_short": "Desblokeatu",
  "account.unblock_short": "Desblokeatu",
  "account.unendorse": "Ez nabarmendu profilean",
  "account.unfollow": "Utzi jarraitzeari",
  "account.unmute": "Desmututu @{name}",
  "account.unmute_notifications_short": "Desmututu jakinarazpenak",
  "account.unmute_short": "Desmututu",
  "admin.dashboard.daily_retention": "Erabiltzaile atxikitze-tasa izena eman ondorengo eguneko",
  "admin.dashboard.monthly_retention": "Erabiltzaile atxikitze-tasa izena eman ondorengo hilabeteko",
  "admin.dashboard.retention.average": "Batezbestekoa",
  "admin.dashboard.retention.cohort": "Izen emate hilean",
  "admin.dashboard.retention.cohort_size": "Erabiltzaile berriak",
  "admin.impact_report.instance_accounts": "Honek ezabatuko lituzkeen kontuen profilak",
  "admin.impact_report.instance_followers": "Gure erabiltzaileek galduko lituzketeen jarraitzaileak",
  "admin.impact_report.instance_follows": "Jarraitzaileek galduko lituzketeen beraien erabiltzaileak",
  "admin.impact_report.title": "Inpaktuaren laburpena",
  "alert.rate_limited.message": "Saiatu {retry_time, time, medium} barru.",
  "alert.rate_limited.title": "Abiadura mugatua",
  "alert.unexpected.message": "Ustekabeko errore bat gertatu da.",
  "alert.unexpected.title": "Ene!",
  "alt_text_badge.title": "Testu alternatiboa",
  "alt_text_modal.add_alt_text": "Gehitu ordezko testua",
  "alt_text_modal.add_text_from_image": "Gehitu testua iruditik",
  "alt_text_modal.cancel": "Utzi",
  "alt_text_modal.change_thumbnail": "Aldatu koadro txikia",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Deskribatu hau entzumen arazoak dituzten pertsonentzat…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Deskribatu hau ikusmen arazoak dituzten pertsonentzat…",
  "alt_text_modal.done": "Egina",
  "announcement.announcement": "Iragarpena",
  "annual_report.announcement.action_build": "Sortu nire Wrapstodon",
  "annual_report.announcement.action_dismiss": "Ez, eskerrik asko",
  "annual_report.announcement.action_view": "Ikusi nire Wrapstodon",
  "annual_report.announcement.description": "Ezagutu azken urtean Mastodonen izan duzun parte-hartzeari buruzko informazio gehiago.",
  "annual_report.announcement.title": "Hemen da {2025}(e)ko Wrapstodon",
  "annual_report.nav_item.badge": "Berria",
  "annual_report.shared_page.donate": "Egin dohaintza",
  "annual_report.shared_page.footer": "Mastodonen taldeak {heart} sortua",
  "annual_report.shared_page.footer_server_info": "{username}(e)k {domain} erabiltzen du, Mastodonek bultzatutako komunitate ugarietako bat.",
  "annual_report.summary.archetype.booster.desc_public": "{name}(e)k promozionatzeko argitalpenen bila jarraitu zuen, beste sortzaile batzuk punteria perfektuarekin anplifikatuz.",
  "annual_report.summary.archetype.booster.desc_self": "Bultzatu beharreko argitalpenen zelatan egon zinen, punteria perfektua zuten beste sortzaile batzuk anplifikatuz.",
  "annual_report.summary.archetype.booster.name": "Arkularia",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Badakigu {name} hor zegoela kanpoan, nonbait, Mastodonez gozatzen bere modu lasaian.",
  "annual_report.summary.archetype.lurker.desc_self": "Badakigu hor zinela kanpoan, nonbait, Mastodonez gozatzen zure erara, isilean.",
  "annual_report.summary.archetype.lurker.name": "Estoikoa",
  "annual_report.summary.archetype.oracle.desc_public": "{name}(e)k erantzun baino argitalpen berri gehiago sortu zituen, eta horrek Mastodon fresko eta etorkizuneko ikuspegiarekin mantendu zuen.",
  "annual_report.summary.archetype.oracle.desc_self": "Erantzun baino argitalpen berri gehiago sortu zenituen, eta horrek Mastodon fresko eta etorkizuneko ikuspegiarekin mantendu zuen.",
  "annual_report.summary.archetype.oracle.name": "Orakulua",
  "annual_report.summary.archetype.pollster.desc_public": "{name}(e)k inkesta gehiago sortu zituen beste argitalpen mota batzuek baino, eta horrek jakin-mina piztu zuen Mastodonen.",
  "annual_report.summary.archetype.pollster.desc_self": "Beste argitalpen batzuk baino inkesta gehiago sortu zenituen, eta horrek jakin-mina piztu zuen Mastodonen.",
  "annual_report.summary.archetype.pollster.name": "Ameslaria",
  "annual_report.summary.archetype.replier.desc_public": "{name}(e)k maiz erantzuten zien beste pertsona batzuen argitalpenei, Mastodon polinizatuz eztabaida berriekin.",
  "annual_report.summary.archetype.replier.desc_self": "Maiz erantzuten zenien beste pertsona batzuen argitalpenei, Mastodon polinizatuz eztabaida berriekin.",
  "annual_report.summary.archetype.replier.name": "Tximeleta",
  "annual_report.summary.archetype.reveal": "Erakutsi nire arketipoa",
  "annual_report.summary.archetype.reveal_description": "Eskerrik asko Mastodonen parte izateagatik! Bada garaia jakiteko zer arketipo haragitu duzun {year}(e)an.",
  "annual_report.summary.archetype.title_public": "{name}-(r)en arketipoa",
  "annual_report.summary.archetype.title_self": "Zure arketipoa",
  "annual_report.summary.close": "Itxi",
  "annual_report.summary.copy_link": "Kopiatu esteka",
  "annual_report.summary.followers.new_followers": "{count, plural, one {jarraitzaile berri} other {jarraitzaile berri}}",
  "annual_report.summary.highlighted_post.boost_count": "Bidalketa honek {count, plural, one {bultzada 1 dauka} other {# bultzada dauzka}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Bidalketa honek {count, plural, one {gogoko 1 dauka} other {# gogoko dauzka}}.",
  "annual_report.summary.highlighted_post.reply_count": "Bidalketa honek {count, plural, one {erantzun 1 dauka} other {# erantzun dauzka}}.",
  "annual_report.summary.highlighted_post.title": "Bidalketa ospetsuena",
  "annual_report.summary.most_used_app.most_used_app": "app erabiliena",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "traola erabiliena",
  "annual_report.summary.most_used_hashtag.used_count": "Traola hau {count, plural, one {bidalketa baten sartu zenuen} other {# bidalketatan sartu zenuen}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name}(e)k traola hau {count, plural, one {bidalketa baten sartu zuen} other {# bidalketatan sartu zituen}}.",
  "annual_report.summary.new_posts.new_posts": "bidalketa berriak",
  "annual_report.summary.percentile.text": "<topLabel>Horrek jartzen zaitu top </topLabel> <percentage> </percentage>(e)an <bottomLabel> {domain} erabiltzaileen artean </bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Bernieri ez diogu ezer esango ;)..",
  "annual_report.summary.share_elsewhere": "Partekatu beste edonon",
  "annual_report.summary.share_message": "{arketipoa} arketipoa daukat!",
  "annual_report.summary.share_on_mastodon": "Partekatu Mastodonen",
  "attachments_list.unprocessed": "(prozesatu gabe)",
  "audio.hide": "Ezkutatu audioa",
  "block_modal.remote_users_caveat": "{domain} zerbitzariari zure erabakia errespeta dezan eskatuko diogu. Halere, araua beteko den ezin da bermatu, zerbitzari batzuk modu desberdinean kudeatzen baitituzte blokeoak. Baliteke argitalpen publikoak saioa hasi ez duten erabiltzaileentzat ikusgai egotea.",
  "block_modal.show_less": "Erakutsi gutxiago",
  "block_modal.show_more": "Erakutsi gehiago",
  "block_modal.they_will_know": "Ezin du ikusi blokeatuta duzunik.",
  "block_modal.title": "Erabiltzailea blokeatu nahi duzu?",
  "boost_modal.combo": "{combo} sakatu dezakezu hurrengoan hau saltatzeko",
  "boost_modal.reblog": "Bultzatu bidalketa?",
  "boost_modal.undo_reblog": "Bidalketari bultzada kendu?",
  "bundle_column_error.copy_stacktrace": "Kopiatu errore-txostena",
  "bundle_column_error.error.body": "Eskatutako orria ezin izan da bistaratu. Kodeko errore bategatik izan daiteke edo nabigatzailearen bateragarritasun arazo bategatik.",
  "bundle_column_error.error.title": "O ez!",
  "bundle_column_error.network.body": "Errore bat gertatu da orri hau kargatzen saiatzean. Arrazoia Interneteko konexioaren edo zerbitzari honen aldi baterako arazoa izan daiteke.",
  "bundle_column_error.network.title": "Sareko errorea",
  "bundle_column_error.retry": "Saiatu berriro",
  "bundle_column_error.return": "Itzuli hasierako orrira",
  "bundle_column_error.routing.body": "Eskatutako orria ezin izan da aurkitu. Ziur helbide-barrako URLa zuzena dela?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Itxi",
  "bundle_modal_error.message": "Zerbait okerra gertatu da pantaila hau kargatzean.",
  "bundle_modal_error.retry": "Saiatu berriro",
  "carousel.current": "{current, number}/{max, number} <sr>diapositiba</sr>",
  "carousel.slide": "{current, number}. diapositiba {max, number}tik",
  "closed_registrations.other_server_instructions": "Mastodon deszentralizatua denez, beste kontu bat sortu dezakezu beste zerbitzari batean eta honekin komunikatu.",
  "closed_registrations_modal.description": "Une honetan ezin da konturik sortu {domain} zerbitzarian, baina kontuan izan Mastodon erabiltzeko ez duzula zertan konturik izan zehazki {domain} zerbitzarian.",
  "closed_registrations_modal.find_another_server": "Aurkitu beste zerbitzari bat",
  "closed_registrations_modal.preamble": "Mastodon deszentralizatua da, ondorioz kontua edonon sortuta ere zerbitzari honetako jendeari jarraitu eta haiekin komunikatzeko aukera izango duzu. Zure zerbitzaria ere sortu dezakezu!",
  "closed_registrations_modal.title": "Mastodonen kontua sortzea",
  "column.about": "Honi buruz",
  "column.blocks": "Blokeatutako erabiltzaileak",
  "column.bookmarks": "Laster-markak",
  "column.community": "Denbora-lerro lokala",
  "column.create_list": "Sortu zerrenda",
  "column.direct": "Aipamen pribatuak",
  "column.directory": "Arakatu profilak",
  "column.domain_blocks": "Ezkutatutako domeinuak",
  "column.edit_list": "Editatu zerrenda",
  "column.favourites": "Gogokoak",
  "column.firehose": "Zuzeneko jarioak",
  "column.firehose_local": "Zerbitzari honen zuzeneko jarioa",
  "column.firehose_singular": "Zuzeneko jarioa",
  "column.follow_requests": "Jarraitzeko eskaerak",
  "column.home": "Hasiera",
  "column.list_members": "Kudeatu zerrrendako partaideak",
  "column.lists": "Zerrendak",
  "column.mutes": "Mutututako erabiltzaileak",
  "column.notifications": "Jakinarazpenak",
  "column.pins": "Finkatutako bidalketak",
  "column.public": "Federatutako denbora-lerroa",
  "column_back_button.label": "Atzera",
  "column_header.hide_settings": "Ezkutatu ezarpenak",
  "column_header.moveLeft_settings": "Eraman zutabea ezkerrera",
  "column_header.moveRight_settings": "Eraman zutabea eskuinera",
  "column_header.pin": "Finkatu",
  "column_header.show_settings": "Erakutsi ezarpenak",
  "column_header.unpin": "Desfinkatu",
  "column_search.cancel": "Utzi",
  "community.column_settings.local_only": "Lokala soilik",
  "community.column_settings.media_only": "Edukiak soilik",
  "community.column_settings.remote_only": "Urrunekoa soilik",
  "compose.error.blank_post": "Bidalketa ezin da hutsik egon.",
  "compose.language.change": "Aldatu hizkuntza",
  "compose.language.search": "Bilatu hizkuntzak...",
  "compose.published.body": "Argitalpena argitaratuta.",
  "compose.published.open": "Ireki",
  "compose.saved.body": "Argitalpena gorde da.",
  "compose_form.direct_message_warning_learn_more": "Ikasi gehiago",
  "compose_form.encryption_warning": "Mastodon-go bidalketak ez daude muturretik muturrera enkriptatuta. Ez partekatu informazio sentikorrik Mastodonen.",
  "compose_form.hashtag_warning": "Tut hau ez da inolako traolatan zerrendatuko, ez baita publikoa. Tut publikoak soilik traolen bitartez bila daitezke.",
  "compose_form.lock_disclaimer": "Zure kontua ez dago {locked}. Edonork jarraitu zaitzake zure jarraitzaileentzako soilik diren bidalketak ikusteko.",
  "compose_form.lock_disclaimer.lock": "giltzapetuta",
  "compose_form.placeholder": "Zer duzu buruan?",
  "compose_form.poll.duration": "Inkestaren iraupena",
  "compose_form.poll.multiple": "Aukera aniza",
  "compose_form.poll.option_placeholder": "{number}. aukera",
  "compose_form.poll.single": "Aukera bakarra",
  "compose_form.poll.switch_to_multiple": "Aldatu inkesta hainbat aukera onartzeko",
  "compose_form.poll.switch_to_single": "Aldatu inkesta aukera bakarra onartzeko",
  "compose_form.poll.type": "Estiloa",
  "compose_form.publish": "Argitaratu",
  "compose_form.reply": "Erantzun",
  "compose_form.save_changes": "Eguneratu",
  "compose_form.spoiler.marked": "Testua abisu batek ezkutatzen du",
  "compose_form.spoiler.unmarked": "Testua ez dago ezkutatuta",
  "compose_form.spoiler_placeholder": "Edukiaren abisua (aukerakoa)",
  "confirmation_modal.cancel": "Utzi",
  "confirmations.block.confirm": "Blokeatu",
  "confirmations.delete.confirm": "Ezabatu",
  "confirmations.delete.message": "Ziur bidalketa hau ezabatu nahi duzula?",
  "confirmations.delete.title": "Ezabatu bidalketa?",
  "confirmations.delete_list.confirm": "Ezabatu",
  "confirmations.delete_list.message": "Ziur behin betiko ezabatu nahi duzula zerrenda hau?",
  "confirmations.delete_list.title": "Ezabatu zerrenda?",
  "confirmations.discard_draft.confirm": "Baztertu eta jarraitu",
  "confirmations.discard_draft.edit.cancel": "Berrekin edizioari",
  "confirmations.discard_draft.edit.message": "Jarraitzeak editatzen ari zaren mezuan egindako aldaketak baztertuko ditu.",
  "confirmations.discard_draft.edit.title": "Baztertu zure argitalpenari egindako aldaketak?",
  "confirmations.discard_draft.post.cancel": "Zirriborroa berrekin",
  "confirmations.discard_draft.post.message": "Jarraituz gero, idazten ari zaren sarrera bertan behera geratuko da.",
  "confirmations.discard_draft.post.title": "Zure argitalpenaren zirriborroa baztertu nahi duzu?",
  "confirmations.discard_edit_media.confirm": "Baztertu",
  "confirmations.discard_edit_media.message": "Multimediaren deskribapen edo aurrebistan gorde gabeko aldaketak daude, baztertu nahi dituzu?",
  "confirmations.follow_to_list.confirm": "Jarraitu eta zerrendan sartu",
  "confirmations.follow_to_list.message": "{name} jarraitu behar duzu zerrenda batean sartzeko.",
  "confirmations.follow_to_list.title": "Erabiltzailea jarraitu?",
  "confirmations.logout.confirm": "Amaitu saioa",
  "confirmations.logout.message": "Ziur saioa amaitu nahi duzula?",
  "confirmations.logout.title": "Itxi saioa?",
  "confirmations.missing_alt_text.confirm": "Gehitu testu alternatiboa",
  "confirmations.missing_alt_text.message": "Zure argitalpenak \"alt text\"-urik gabeko multimedia edukia dauka. Deskribapenak gehitzeak zure edukia jende gehiagorentzat eskuragarri jartzen laguntzen du.",
  "confirmations.missing_alt_text.secondary": "Bidali edonola ere",
  "confirmations.missing_alt_text.title": "Testu alternatiboa gehitu?",
  "confirmations.mute.confirm": "Mututu",
  "confirmations.private_quote_notify.cancel": "Bueltatu ediziora",
  "confirmations.private_quote_notify.confirm": "Argitaratu bidalketa",
  "confirmations.private_quote_notify.do_not_show_again": "Ez erakutsi mezu hau berriro",
  "confirmations.private_quote_notify.message": "Aipatzen ari zaren pertsonak eta aipatutako besteek jakinarazpena jasoko dute eta zure sarrera ikusi ahalko dute, zure jarraitzaileak ez badira ere.",
  "confirmations.private_quote_notify.title": "Partekatu jarraitzaileekin eta aipatutako erabiltzaileekin?",
  "confirmations.quiet_post_quote_info.dismiss": "Ez gogorarazi berriro",
  "confirmations.quiet_post_quote_info.got_it": "Ulertuta",
  "confirmations.quiet_post_quote_info.message": "Deiadar urriko bidalketa bat aipatzen duzunean, zure bidalketa joeretatik ezkutatuko da.",
  "confirmations.quiet_post_quote_info.title": "Deiadar urriko bidalketaren aipua",
  "confirmations.redraft.confirm": "Ezabatu eta berridatzi",
  "confirmations.redraft.message": "Ziur argitalpen hau ezabatu eta zirriborroa berriro egitea nahi duzula? Gogokoak eta bultzadak galduko dira, eta jatorrizko argitalpenaren erantzunak zurtz geratuko dira.",
  "confirmations.redraft.title": "Ezabatu eta berridatzi bidalketa?",
  "confirmations.remove_from_followers.confirm": "Jarraitzailea Kendu",
  "confirmations.remove_from_followers.message": "{name}-k zu jarraitzeari utziko dio. Seguru zaude jarraitu nahi duzula?",
  "confirmations.remove_from_followers.title": "Jarraitzailea kendu nahi duzu?",
  "confirmations.revoke_quote.confirm": "Ezabatu bidalketa",
  "confirmations.revoke_quote.message": "Ekintza hau ezin da desegin.",
  "confirmations.revoke_quote.title": "Ezabatu bidalketa?",
  "confirmations.unblock.confirm": "Desblokeatu",
  "confirmations.unblock.title": "Desblokeatu {name}?",
  "confirmations.unfollow.confirm": "Utzi jarraitzeari",
  "confirmations.unfollow.title": "{name} jarraitzeari utzi?",
  "confirmations.withdraw_request.confirm": "Baztertu eskaera",
  "confirmations.withdraw_request.title": "Baztertu {name} jarraitzeko eskaera?",
  "content_warning.hide": "Tuta ezkutatu",
  "content_warning.show": "Erakutsi hala ere",
  "content_warning.show_more": "Erakutsi gehiago",
  "conversation.delete": "Ezabatu elkarrizketa",
  "conversation.mark_as_read": "Markatu irakurrita bezala",
  "conversation.open": "Ikusi elkarrizketa",
  "conversation.with": "Hauekin: {names}",
  "copy_icon_button.copied": "Arbelera kopiatu da",
  "copypaste.copied": "Kopiatuta",
  "copypaste.copy_to_clipboard": "Kopiatu arbelera",
  "directory.federated": "Fedibertso ezagunekoak",
  "directory.local": "{domain} domeinukoak soilik",
  "directory.new_arrivals": "Iritsi berriak",
  "directory.recently_active": "Duela gutxi aktibo",
  "disabled_account_banner.account_settings": "Kontuaren ezarpenak",
  "disabled_account_banner.text": "Zure {disabledAccount} kontua desgaituta dago une honetan.",
  "dismissable_banner.community_timeline": "Hauek dira {domain} zerbitzarian ostatatutako kontuen bidalketa publiko berrienak.",
  "dismissable_banner.dismiss": "Baztertu",
  "dismissable_banner.public_timeline": "Hauek dira {domain}-eko jendeak jarraitzen dituen fedibertsoko erabiltzaileen azken mezu publikoak.",
  "domain_block_modal.block": "Blokeatu zerbitzaria",
  "domain_block_modal.block_account_instead": "Blokeatu @{name} bestela",
  "domain_block_modal.they_can_interact_with_old_posts": "Zerbitzari honetako jendea zure argitalpen zaharrekin elkarreragin dezake.",
  "domain_block_modal.they_cant_follow": "Zerbitzari honetako inork ezin zaitu jarraitu.",
  "domain_block_modal.they_wont_know": "Ez dute jakingo blokeatuak izan direnik.",
  "domain_block_modal.title": "Domeinua blokeatu nahi duzu?",
  "domain_block_modal.you_will_lose_num_followers": "{followersCount, plural, one {Jarraitzaile {followersCountDisplay}} other {{followersCountDisplay} jarraitzaile}} eta {followingCount, plural, one {jarraitzen duzun pertsona {followingCountDisplay}} other {jarraitzen dituzun beste {followingCountDisplay} pertsona}} galduko dituzu.",
  "domain_block_modal.you_will_lose_relationships": "Instantzia honetatik jarraitzen dituzun jarraitzaile eta pertsona guztiak galduko dituzu.",
  "domain_block_modal.you_wont_see_posts": "Ez dituzu zerbitzari honetako erabiltzaileen argitalpenik edota jakinarazpenik ikusiko.",
  "dropdown.empty": "Aukeratu bat",
  "embed.instructions": "Txertatu bidalketa hau zure webgunean beheko kodea kopiatuz.",
  "embed.preview": "Hau da izango duen itxura:",
  "emoji_button.activity": "Jarduera",
  "emoji_button.clear": "Garbitu",
  "emoji_button.custom": "Pertsonalizatua",
  "emoji_button.flags": "Banderak",
  "emoji_button.food": "Janari eta edaria",
  "emoji_button.label": "Txertatu emoji-a",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Emojirik ez!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objektuak",
  "emoji_button.people": "Jendea",
  "emoji_button.recent": "Maiz erabiliak",
  "emoji_button.search": "Bilatu...",
  "emoji_button.search_results": "Bilaketaren emaitzak",
  "emoji_button.symbols": "Sinboloak",
  "emoji_button.travel": "Bidaiak eta tokiak",
  "empty_column.account_hides_collections": "Erabiltzaile honek informazio hau erabilgarri ez egotea aukeratu du.",
  "empty_column.account_suspended": "Kanporatutako kontua",
  "empty_column.account_timeline": "Ez dago bidalketarik hemen!",
  "empty_column.account_unavailable": "Profila ez dago eskuragarri",
  "empty_column.blocks": "Ez duzu erabiltzailerik blokeatu oraindik.",
  "empty_column.bookmarked_statuses": "Oraindik ez dituzu bidalketa laster-markatutarik. Bat laster-markatzerakoan, hemen agertuko da.",
  "empty_column.community": "Denbora-lerro lokala hutsik dago. Idatzi zerbait publikoki pilota biraka jartzeko!",
  "empty_column.direct": "Ez duzu aipamen pribaturik oraindik. Baten bat bidali edo jasotzen duzunean, hemen agertuko da.",
  "empty_column.disabled_feed": "Zure zerbitzariko administratzaileek jario hau desgaitu dute.",
  "empty_column.domain_blocks": "Ez dago ezkutatutako domeinurik oraindik.",
  "empty_column.explore_statuses": "Ez dago joerarik une honetan. Begiratu beranduago!",
  "empty_column.favourited_statuses": "Ez duzu gogokorik oraindik. Gogoko bat duzunean, hemen agertuko da.",
  "empty_column.favourites": "Inork ez du oraindik bidalketa hau gogokoetara gehitu. Norbaitek egiten duenean, hemen agertuko dira.",
  "empty_column.follow_requests": "Ez duzu jarraitzeko eskaerarik oraindik. Baten bat jasotzen duzunean, hemen agertuko da.",
  "empty_column.followed_tags": "Oraindik ez duzu traolik jarraitzen. Egiterakoan, hemen agertuko dira.",
  "empty_column.hashtag": "Ez dago ezer traola honetan oraindik.",
  "empty_column.home": "Zure hasierako denbora-lerroa hutsik dago! Jarraitu jende gehiago betetzeko.",
  "empty_column.list": "Ez dago ezer zerrenda honetan. Zerrenda honetako kideek bidalketa berriak argitaratzean, hemen agertuko dira.",
  "empty_column.mutes": "Ez duzu erabiltzailerik mututu oraindik.",
  "empty_column.notification_requests": "Garbi-garbi! Ezertxo ere ez hemen. Jakinarazpenak jasotzen dituzunean, hemen agertuko dira zure ezarpenen arabera.",
  "empty_column.notifications": "Ez duzu jakinarazpenik oraindik. Jarri besteekin harremanetan elkarrizketa abiatzeko.",
  "empty_column.public": "Ez dago ezer hemen! Idatzi zerbait publikoki edo jarraitu eskuz beste zerbitzari batzuetako erabiltzaileei hau betetzen joateko",
  "error.no_hashtag_feed_access": "Egin bat edo hasi saioa etiketa hau ikusi eta jarraitzeko.",
  "error.unexpected_crash.explanation": "Gure kodean arazoren bat dela eta, edo nabigatzailearekin bateragarritasun arazoren bat dela eta, orri hau ezin izan da ongi bistaratu.",
  "error.unexpected_crash.explanation_addons": "Ezin izan da orria behar bezala bistaratu. Errore honen jatorria nabigatzailearen gehigarri batean edo itzulpen automatikoko tresnetan dago ziur aski.",
  "error.unexpected_crash.next_steps": "Saiatu orria berritzen. Horrek ez badu laguntzen, agian Mastodon erabiltzeko aukera duzu oraindik ere beste nabigatzaile bat edo aplikazio natibo bat erabilita.",
  "error.unexpected_crash.next_steps_addons": "Saiatu desgaitu eta orria berritzen. Horrek ez badu laguntzen, agian Mastodon erabiltzeko aukera duzu oraindik ere beste nabigatzaile bat edo aplikazio natibo bat erabilita.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiatu irteera arbelera",
  "errors.unexpected_crash.report_issue": "Eman arazoaren berri",
  "explore.suggested_follows": "Jendea",
  "explore.title": "Joerak",
  "explore.trending_links": "Berriak",
  "explore.trending_statuses": "Tutak",
  "explore.trending_tags": "Traolak",
  "featured_carousel.current": "{current, number}/{max, number} <sr>sarrera</sr>",
  "featured_carousel.header": "{count, plural, one {Finkatutako sarrera} other {Finkatutako sarrerak}}",
  "featured_carousel.slide": "{current, number}. sarrera {max, number}tik",
  "filter_modal.added.context_mismatch_explanation": "Iragazki-kategoria hau ez zaio aplikatzen bidalketa honetara sartzeko erabili duzun testuinguruari. Bidalketa testuinguru horretan ere iragaztea nahi baduzu, iragazkia editatu beharko duzu.",
  "filter_modal.added.context_mismatch_title": "Testuingurua ez dator bat!",
  "filter_modal.added.expired_explanation": "Iragazki kategoria hau iraungi da, eragina izan dezan bere iraungitze-data aldatu beharko duzu.",
  "filter_modal.added.expired_title": "Iraungitako iragazkia!",
  "filter_modal.added.review_and_configure": "Iragazki kategoria hau berrikusi eta gehiago konfiguratzeko: {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Iragazkiaren ezarpenak",
  "filter_modal.added.settings_link": "ezarpenen orria",
  "filter_modal.added.short_explanation": "Bidalketa hau ondorengo iragazki kategoriara gehitu da: {title}.",
  "filter_modal.added.title": "Iragazkia gehituta!",
  "filter_modal.select_filter.context_mismatch": "ez du eraginik testuinguru honetan",
  "filter_modal.select_filter.expired": "iraungitua",
  "filter_modal.select_filter.prompt_new": "Kategoria berria: {name}",
  "filter_modal.select_filter.search": "Bilatu edo sortu",
  "filter_modal.select_filter.subtitle": "Hautatu lehendik dagoen kategoria bat edo sortu berria",
  "filter_modal.select_filter.title": "Iragazi bidalketa hau",
  "filter_modal.title.status": "Iragazi bidalketa bat",
  "filter_warning.matches_filter": "“<span>{title}</span>” iragazkiarekin bat dator",
  "filtered_notifications_banner.pending_requests": "Ezagutu dezakezun {count, plural, =0 {inoren} one {pertsona baten} other {# pertsonen}}",
  "filtered_notifications_banner.title": "Iragazitako jakinarazpenak",
  "firehose.all": "Guztiak",
  "firehose.local": "Zerbitzari hau",
  "firehose.remote": "Beste zerbitzariak",
  "follow_request.authorize": "Baimendu",
  "follow_request.reject": "Ukatu",
  "follow_requests.unlocked_explanation": "Zure kontua blokeatuta ez badago ere, {domain} domeinuko arduradunek uste dute kontu hauetako jarraipen eskaerak agian eskuz begiratu nahiko dituzula.",
  "follow_suggestions.curated_suggestion": "Domeinuaren iradokizuna",
  "follow_suggestions.dismiss": "Ez erakutsi berriro",
  "follow_suggestions.featured_longer": "{domain} domeinuko taldeak hautaturikoak",
  "follow_suggestions.friends_of_friends_longer": "Jarraitzen duzun jendearen artean ezagunak direnak",
  "follow_suggestions.hints.featured": "Profil hau {domain} domeinuko taldeak eskuz aukeratu du.",
  "follow_suggestions.hints.friends_of_friends": "Profil hau ezaguna da jarraitzen duzun jendearen artean.",
  "follow_suggestions.hints.most_followed": "Profil hau {domain} domeinuan gehien jarraitzen den profiletako bat da.",
  "follow_suggestions.hints.most_interactions": "Profil hau arreta handia jasotzen ari da berriki {domain} domeinuan.",
  "follow_suggestions.hints.similar_to_recently_followed": "Profil hau duela gutxi jarraitu dituzun profil askoren antzekoa da.",
  "follow_suggestions.personalized_suggestion": "Iradokizun pertsonalizatua",
  "follow_suggestions.popular_suggestion": "Iradokizun ezaguna",
  "follow_suggestions.popular_suggestion_longer": "{domain} domeinuan ezagunak direnak",
  "follow_suggestions.similar_to_recently_followed_longer": "Berriki jarraitu dituzun profilen antzekoa",
  "follow_suggestions.view_all": "Ikusi denak",
  "follow_suggestions.who_to_follow": "Zein jarraitu",
  "followed_tags": "Jarraitutako traolak",
  "footer.about": "Honi buruz",
  "footer.about_mastodon": "Mastodoni buruz",
  "footer.about_server": "{domain}-i buruz",
  "footer.about_this_server": "Honi buruz",
  "footer.directory": "Profil-direktorioa",
  "footer.get_app": "Eskuratu aplikazioa",
  "footer.keyboard_shortcuts": "Lasterbideak",
  "footer.privacy_policy": "Pribatutasun politika",
  "footer.source_code": "Ikusi iturburu kodea",
  "footer.status": "Egoera",
  "footer.terms_of_service": "Erabilera baldintzak",
  "getting_started.heading": "Menua",
  "hashtag.admin_moderation": "#{name}-(r)en moderazio-interfazea ireki",
  "hashtag.browse": "Arakatu bidalketak #{hashtag}(e)n",
  "hashtag.browse_from_account": "Arakatu @{name}(r)en bidalketak #{hashtag}(e)n",
  "hashtag.column_header.tag_mode.all": "eta {osagarria}",
  "hashtag.column_header.tag_mode.any": "edo {osagarria}",
  "hashtag.column_header.tag_mode.none": "gabe {osagarria}",
  "hashtag.column_settings.select.no_options_message": "Ez da proposamenik aurkitu",
  "hashtag.column_settings.select.placeholder": "Sartu traolak…",
  "hashtag.column_settings.tag_mode.all": "Hauetako guztiak",
  "hashtag.column_settings.tag_mode.any": "Hautako edozein",
  "hashtag.column_settings.tag_mode.none": "Hauetako bat ere ez",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} parte-hartzaile} other {{counter} parte-hartzaile}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} argitalpen} other {{counter} argitalpen}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} argitalpen} other {{counter} argitalpen}} gaur",
  "hashtag.feature": "Nabarmendu profilean",
  "hashtag.follow": "Jarraitu traolari",
  "hashtag.mute": "Mututu #{hashtag}",
  "hashtag.unfeature": "Ez nabarmendu profilean",
  "hashtag.unfollow": "Utzi traola jarraitzeari",
  "hashtags.and_other": "…eta {count, plural, one {}other {# gehiago}}",
  "hints.profiles.followers_may_be_missing": "Baliteke profil honen jarraitzaile guztiak ez agertzea.",
  "hints.profiles.follows_may_be_missing": "Baliteke profil honek jarraitzen dituen profil guztiak ez erakustea.",
  "hints.profiles.posts_may_be_missing": "Baliteke profil honen tut guztiak ez erakustea.",
  "hints.profiles.see_more_followers": "Ikusi jarraitzaile gehiago {domain}-(e)n",
  "hints.profiles.see_more_follows": "Ikusi jarraitzaile gehiago {domain}-(e)n",
  "hints.profiles.see_more_posts": "Ikusi bidalketa gehiago {domain}-(e)n",
  "home.column_settings.show_quotes": "Erakutsi aipamenak",
  "home.column_settings.show_reblogs": "Erakutsi bultzadak",
  "home.column_settings.show_replies": "Erakutsi erantzunak",
  "home.hide_announcements": "Ezkutatu iragarpenak",
  "home.pending_critical_update.body": "Eguneratu zure Mastodon-go zerbitzaria leheinbailehen!",
  "home.pending_critical_update.link": "Ikusi eguneraketak",
  "home.pending_critical_update.title": "Segurtasun eguneraketa kritikoa eskuragarri!",
  "home.show_announcements": "Erakutsi iragarpenak",
  "ignore_notifications_modal.disclaimer": "Mastodonek ezin die jakinarazi erabiltzaileei beraien jakinarazpenei ezikusiarena egingo diezula. Jakinarazpenei ezikusiarena egiteak ez du eragotziko mezuak bidaltzen jarraitzea.",
  "ignore_notifications_modal.filter_instead": "Iragazi ez ikusiarena egin beharrean",
  "ignore_notifications_modal.filter_to_act_users": "Oraindik ere erabiltzaileak onartu, baztertu edo salatu ahal izango dituzu",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Iragazteak nahaste potentzialak saihesten laguntzen du",
  "ignore_notifications_modal.filter_to_review_separately": "Banaka berrikus ditzakezu iragazitako jakinarazpenak",
  "ignore_notifications_modal.ignore": "Ezikusi jakinarazpenak",
  "ignore_notifications_modal.limited_accounts_title": "Moderatutako kontuen jakinarazpenei ez ikusiarena egin?",
  "ignore_notifications_modal.new_accounts_title": "Kontu berrien jakinarazpenei ez ikusiarena egin?",
  "ignore_notifications_modal.not_followers_title": "Jarraitzen ez zaituzten pertsonen jakinarazpenei ez ikusiarena egin?",
  "ignore_notifications_modal.not_following_title": "Jarraitzen ez dituzun pertsonen jakinarazpenei ez ikusiarena egin?",
  "ignore_notifications_modal.private_mentions_title": "Eskatu gabeko aipamen pribatuen jakinarazpenei ez ikusiarena egin?",
  "info_button.label": "Laguntza",
  "info_button.what_is_alt_text": "<h1>Zer da Alt testua?</h1><p>Alt testuak irudiak deskribatzeko aukera ematen du, ikusmen-urritasunak, banda-zabalera txikiko konexioak edo testuinguru gehigarria nahi duten pertsonentzat.</p><p>Alt testu argi, zehatz eta objektiboen bidez, guztion irisgarritasuna eta ulermena hobetu ditzakezu.</p><ul><li>Hartu elementu garrantzitsuenak</li><li>Laburbildu irudietako testua</li><li>Erabili esaldien egitura erregularra</li><li>Baztertu informazio erredundantea.</li><li>Enfokatu joeretan eta funtsezko elementuetan irudi konplexuetan (diagrametan edo mapetan, adibidez)</li></ul>",
  "interaction_modal.action": "{name} erabiltzailearen sarrerarekin interaktuatzeko, saioa hasi behar duzu erabiltzen duzun Mastodon zerbitzarian.",
  "interaction_modal.go": "Joan",
  "interaction_modal.no_account_yet": "Ez al duzu konturik oraindik?",
  "interaction_modal.on_another_server": "Beste zerbitzari batean",
  "interaction_modal.on_this_server": "Zerbitzari honetan",
  "interaction_modal.title": "Hasi saioa jarraitzeko",
  "interaction_modal.username_prompt": "Adib. {example}",
  "intervals.full.days": "{number, plural, one {egun #} other {# egun}}",
  "intervals.full.hours": "{number, plural, one {ordu #} other {# ordu}}",
  "intervals.full.minutes": "{number, plural, one {minutu #} other {# minutu}}",
  "keyboard_shortcuts.back": "atzera nabigatzeko",
  "keyboard_shortcuts.blocked": "blokeatutako erabiltzaileen zerrenda irekitzeko",
  "keyboard_shortcuts.boost": "Bultzatu bidalketa",
  "keyboard_shortcuts.column": "mezu bat zutabe batean fokatzea",
  "keyboard_shortcuts.compose": "testua konposatzeko arean fokatzea",
  "keyboard_shortcuts.description": "Deskripzioa",
  "keyboard_shortcuts.down": "zerrendan behera mugitzea",
  "keyboard_shortcuts.enter": "Ireki bidalketa",
  "keyboard_shortcuts.favourite": "Egin gogoko bidalketa",
  "keyboard_shortcuts.favourites": "Ireki gogokoen zerrenda",
  "keyboard_shortcuts.federated": "federatutako denbora-lerroa irekitzeko",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "hasierako denbora-lerroa irekitzeko",
  "keyboard_shortcuts.hotkey": "Laster-tekla",
  "keyboard_shortcuts.legend": "legenda hau bistaratzea",
  "keyboard_shortcuts.load_more": "Fokuratu \"Kargatu gehiago\" botoia",
  "keyboard_shortcuts.local": "denbora-lerro lokala irekitzeko",
  "keyboard_shortcuts.mention": "egilea aipatzea",
  "keyboard_shortcuts.muted": "mutututako erabiltzaileen zerrenda irekitzeko",
  "keyboard_shortcuts.my_profile": "zure profila irekitzeko",
  "keyboard_shortcuts.notifications": "jakinarazpenen zutabea irekitzeko",
  "keyboard_shortcuts.open_media": "Ireki edukia",
  "keyboard_shortcuts.pinned": "Ireki finkatutako bidalketen zerrenda",
  "keyboard_shortcuts.profile": "egilearen profila irekitzeko",
  "keyboard_shortcuts.quote": "Aipatu sarrera",
  "keyboard_shortcuts.reply": "Erantzun bidalketari",
  "keyboard_shortcuts.requests": "Jarraitzeko eskaeren zerrenda irekia",
  "keyboard_shortcuts.search": "bilaketan fokua jartzea",
  "keyboard_shortcuts.spoilers": "CW eremua erakutsi/ezkutatzeko",
  "keyboard_shortcuts.start": "\"Menua\" zutabea irekitzeko",
  "keyboard_shortcuts.toggle_hidden": "testua erakustea/ezkutatzea abisu baten atzean",
  "keyboard_shortcuts.toggle_sensitivity": "multimedia erakutsi/ezkutatzeko",
  "keyboard_shortcuts.toot": "Hasi bidalketa berri bat",
  "keyboard_shortcuts.top": "Mugitu zerrendaren hasierara",
  "keyboard_shortcuts.unfocus": "testua konposatzeko area / bilaketatik fokua kentzea",
  "keyboard_shortcuts.up": "zerrendan gora mugitzea",
  "learn_more_link.got_it": "Ulertuta",
  "learn_more_link.learn_more": "Ikasi gehiago",
  "lightbox.close": "Itxi",
  "lightbox.next": "Hurrengoa",
  "lightbox.previous": "Aurrekoa",
  "lightbox.zoom_in": "Zooma egungo tamainara",
  "lightbox.zoom_out": "Zooma egokitzeko",
  "limited_account_hint.action": "Erakutsi profila hala ere",
  "link_preview.author": "Egilea: {name}",
  "link_preview.more_from_author": "{name} erabiltzaileaz gehiago jakin",
  "link_preview.shares": "{count, plural, one {{counter} bidalketa} other {{counter} bidalketa}}",
  "lists.add_member": "Gehitu",
  "lists.add_to_list": "Gehitu zerrendara",
  "lists.add_to_lists": "Gehitu {name} zerrendetara",
  "lists.create": "Sortu",
  "lists.create_a_list_to_organize": "Sortu zerrenda berria zure Hasierako jarioa antolatzeko",
  "lists.create_list": "Sortu zerrenda",
  "lists.delete": "Ezabatu zerrenda",
  "lists.done": "Egina",
  "lists.edit": "Editatu zerrenda",
  "lists.exclusive": "Ezkutatu kideak Hasieran",
  "lists.exclusive_hint": "Norbait zerrenda honetan badago, ezkutatu zure Hasierako jariotik mezuak bi aldiz ez ikusteko.",
  "lists.find_users_to_add": "Bilatu erabiltzaileak gehitzeko",
  "lists.list_members_count": "{count, plural, one {kide #} other {# kide}}",
  "lists.list_name": "Zerrenda izena",
  "lists.new_list_name": "Zerrenda izen berria",
  "lists.no_lists_yet": "Ez duzu zerrendarik oraindik.",
  "lists.no_members_yet": "Ez duzu kiderik oraindik.",
  "lists.no_results_found": "Ez da emaitzarik aurkitu.",
  "lists.remove_member": "Ezabatu",
  "lists.replies_policy.followed": "Jarraitutako edozein erabiltzaile",
  "lists.replies_policy.list": "Zerrendako kideak",
  "lists.replies_policy.none": "Bat ere ez",
  "lists.save": "Gorde",
  "lists.search": "Bilatu",
  "lists.show_replies_to": "Erakutsi zerrendako kideen erantzunak hauei:",
  "load_pending": "{count, plural, one {elementu berri #} other {# elementu berri}}",
  "loading_indicator.label": "Kargatzen…",
  "media_gallery.hide": "Ezkutatu",
  "moved_to_account_banner.text": "Zure {disabledAccount} kontua desgaituta dago une honetan, {movedToAccount} kontura aldatu zinelako.",
  "mute_modal.hide_from_notifications": "Ezkutatu jakinarazpenetatik",
  "mute_modal.hide_options": "Ezkutatu aukerak",
  "mute_modal.indefinite": "Desmututua izan arte",
  "mute_modal.show_options": "Erakutsi aukerak",
  "mute_modal.they_can_mention_and_follow": "Aipa eta jarrai zaitzakete, baina ez dituzu ikusiko.",
  "mute_modal.they_wont_know": "Ez dute jakingo mututuak izan direnik.",
  "mute_modal.title": "Erabiltzailea mututu nahi duzu?",
  "mute_modal.you_wont_see_mentions": "Ez duzu ikusiko bera aipatzen duen argitalpenik.",
  "mute_modal.you_wont_see_posts": "Zure argitalpenak ikus ditzake, baina ez dituzu bereak ikusiko.",
  "navigation_bar.about": "Honi buruz",
  "navigation_bar.account_settings": "Pasahitza eta segurtasuna",
  "navigation_bar.administration": "Administrazioa",
  "navigation_bar.advanced_interface": "Ireki web interfaze aurreratuan",
  "navigation_bar.automated_deletion": "Bidalketa automatikoaren ezabaketa",
  "navigation_bar.blocks": "Blokeatutako erabiltzaileak",
  "navigation_bar.bookmarks": "Laster-markak",
  "navigation_bar.direct": "Aipamen pribatuak",
  "navigation_bar.domain_blocks": "Ezkutatutako domeinuak",
  "navigation_bar.favourites": "Gogokoak",
  "navigation_bar.filters": "Mutututako hitzak",
  "navigation_bar.follow_requests": "Jarraitzeko eskaerak",
  "navigation_bar.followed_tags": "Jarraitutako traolak",
  "navigation_bar.follows_and_followers": "Jarraitutakoak eta jarraitzaileak",
  "navigation_bar.import_export": "Inportazioa eta esportazioa",
  "navigation_bar.lists": "Zerrendak",
  "navigation_bar.live_feed_local": "Zuzeneko jarioa (lokala)",
  "navigation_bar.live_feed_public": "Zuzeneko jarioa (publikoa)",
  "navigation_bar.logout": "Amaitu saioa",
  "navigation_bar.moderation": "Moderazioa",
  "navigation_bar.more": "Gehiago",
  "navigation_bar.mutes": "Mutututako erabiltzaileak",
  "navigation_bar.opened_in_classic_interface": "Argitalpenak, kontuak eta beste orri jakin batzuk lehenespenez irekitzen dira web-interfaze klasikoan.",
  "navigation_bar.preferences": "Hobespenak",
  "navigation_bar.privacy_and_reach": "Pribatutasuna eta irismena",
  "navigation_bar.search": "Bilatu",
  "navigation_bar.search_trends": "Bilatu / Joera",
  "navigation_panel.collapse_followed_tags": "Itxi jarraitzen dituzun traolen menua",
  "navigation_panel.collapse_lists": "Itxi zerrenden menua",
  "navigation_panel.expand_followed_tags": "Zabaldu jarraitzen dituzun traolen menua",
  "navigation_panel.expand_lists": "Zabaldu zerrenden menua",
  "not_signed_in_indicator.not_signed_in": "Baliabide honetara sarbidea izateko saioa hasi behar duzu.",
  "notification.admin.report": "{name} erabiltzaileak {target} salatu du",
  "notification.admin.report_account": "{name}-(e)k {target}-ren {count, plural, one {bidalketa bat} other {# bidalketa}} salatu zituen {category} delakoagatik",
  "notification.admin.report_account_other": "{name}-(e)k {target}-ren {count, plural, one {bidalketa bat salatu zuen} other {# bidalketa salatu zituen}}",
  "notification.admin.report_statuses": "{name}-(e)k {target} salatu zuen {category} delakoagatik",
  "notification.admin.report_statuses_other": "{name} erabiltzaileak {target} salatu du",
  "notification.admin.sign_up": "{name} erabiltzailea erregistratu da",
  "notification.admin.sign_up.name_and_others": "{name} eta {count, plural, one {erabiltzaile # gehiago} other {# erabiltzaile gehiago}} erregistratu dira",
  "notification.annual_report.message": "Zain duzu {year}(e)ko #Wrapstodon! Ikusi urteko zure unerik gogoangarrienak Mastodonen!",
  "notification.annual_report.view": "Ikusi #Wrapstodon",
  "notification.favourite": "{name}(e)k zure bidalketa gogoko du",
  "notification.favourite.name_and_others_with_link": "{name} eta <a>{count, plural, one {erabiltzaile # gehiagok} other {# erabiltzaile gehiagok}}</a> zure bidalketa gogoko dute",
  "notification.favourite_pm": "{name}-ek zure aipamen pribatua gogokoetan jarri du",
  "notification.favourite_pm.name_and_others_with_link": "{name} erabiltzaileak eta beste <a>{count, plural, one {#ek} other {#(e)k}}</a> gogoko dute zure aipu pribatua",
  "notification.follow": "{name}(e)k jarraitzen dizu",
  "notification.follow.name_and_others": "{name} erabiltzaileak eta <a>{count, plural, one {# gehiagok} other {# gehiagok}}</a> jarraitu dizute",
  "notification.follow_request": "{name}(e)k zu jarraitzeko eskaera egin du",
  "notification.follow_request.name_and_others": "{name} eta {count, plural, one {erabiltzaile # gehiagok} other {# erabiltzaile gehiagok}} zu jarraitzeko eskaera egin dute",
  "notification.label.mention": "Aipamena",
  "notification.label.private_mention": "Aipamen pribatua",
  "notification.label.private_reply": "Erantzun pribatua",
  "notification.label.quote": "{name} erabiltzaileak zure bidalketa aipatu du",
  "notification.label.reply": "Erantzuna",
  "notification.mention": "Aipamena",
  "notification.mentioned_you": "{name}(e)k aipatu zaitu",
  "notification.moderation-warning.learn_more": "Informazio gehiago",
  "notification.moderation_warning": "Moderazio-abisu bat jaso duzu",
  "notification.moderation_warning.action_delete_statuses": "Argitalpen batzuk kendu dira.",
  "notification.moderation_warning.action_disable": "Zure kontua desaktibatua izan da.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Argitalpen batzuk hunkigarri gisa ezarri dira.",
  "notification.moderation_warning.action_none": "Kontuak moderazio-abisu bat jaso du.",
  "notification.moderation_warning.action_sensitive": "Argitalpenak hunkigarri gisa markatuko dira hemendik aurrera.",
  "notification.moderation_warning.action_silence": "Kontua murriztu egin da.",
  "notification.moderation_warning.action_suspend": "Kontua itxi da.",
  "notification.own_poll": "Zure inkesta amaitu da",
  "notification.poll": "Zuk erantzun duzun inkesta bat bukatu da",
  "notification.quoted_update": "{name} erabiltzaileak aipatu duzun post bat editatu du",
  "notification.reblog": "{name}(e)k bultzada eman dio zure bidalketari",
  "notification.reblog.name_and_others_with_link": "{name} eta <a>{count, plural, one {erabiltzaile # gehiagok} other {# erabiltzaile gehiagok}}</a> bultzada eman diote zure bidalketari",
  "notification.relationships_severance_event": "{name} erabiltzailearekin galdutako konexioak",
  "notification.relationships_severance_event.account_suspension": "{from} zerbitzariko administratzaile batek {target} bertan behera utzi du, hau da, ezin izango dituzu jaso hango eguneratzerik edo hangoekin elkarreragin.",
  "notification.relationships_severance_event.domain_block": "{from} zerbitzariko administratzaile batek {target} blokeatu du, tartean zure {followersCount} jarraitzaile eta jarraitzen duzun {followingCount, plural, one {kontu #} other {# kontu}}.",
  "notification.relationships_severance_event.learn_more": "Informazio gehiago",
  "notification.relationships_severance_event.user_domain_block": "{target} blokeatu duzu, tartean zure {followersCount} jarraitzaile eta jarraitzen duzun {followingCount, plural, one {kontu #} other {# kontu}}.",
  "notification.status": "{name} erabiltzaileak bidalketa egin berri du",
  "notification.update": "{name} erabiltzaileak bidalketa bat editatu du",
  "notification_requests.accept": "Onartu",
  "notification_requests.accept_multiple": "{count, plural, one {Onartu eskaera…} other {Onartu # eskaerak…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Onartu eskaera} other {Onartu eskaerak}}",
  "notification_requests.confirm_accept_multiple.message": "{count, plural, one {Jakinarazpen eskaera bat} other {# jakinarazpen eskaera}} onartzekotan zaude. Jarraitu nahi duzu?",
  "notification_requests.confirm_accept_multiple.title": "Onartu jakinarazpen-eskaerak?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Baztertu eskaera} other {Baztertu eskaerak}}",
  "notification_requests.confirm_dismiss_multiple.message": "{count, plural, one {Jakinarazpen eskaera bat} other {# jakinarazpen eskaera}} baztertzekotan zaude. Gerora ezingo {count, plural, one {duzu} other {dituzu}} berriz erraz atzitu. Jarraitu nahi duzu?",
  "notification_requests.confirm_dismiss_multiple.title": "Baztertu jakinarazpen-eskaerak?",
  "notification_requests.dismiss": "Baztertu",
  "notification_requests.dismiss_multiple": "{count, plural, one {Baztertu eskaera…} other {Baztertu # eskaerak…}}",
  "notification_requests.edit_selection": "Editatu",
  "notification_requests.exit_selection": "Egina",
  "notification_requests.explainer_for_limited_account": "Kontu honen jakinarazpenak iragazi egin dira, kontua moderatzaile batek mugatu duelako.",
  "notification_requests.explainer_for_limited_remote_account": "Kontu horren jakinarazpenak iragazi egin dira kontua edo bere zerbitzaria moderatzaile batek mugatu duelako.",
  "notification_requests.maximize": "Maximizatu",
  "notification_requests.minimize_banner": "Minimizatu iragazitako jakinarazpenen bannerra",
  "notification_requests.notifications_from": "{name} erabiltzailearen jakinarazpenak",
  "notification_requests.title": "Iragazitako jakinarazpenak",
  "notification_requests.view": "Ikusi jakinarazpenak",
  "notifications.clear": "Garbitu jakinarazpenak",
  "notifications.clear_confirmation": "Ziur zure jakinarazpen guztiak behin betirako garbitu nahi dituzula?",
  "notifications.clear_title": "Garbitu jakinarazpenak?",
  "notifications.column_settings.admin.report": "Txosten berriak:",
  "notifications.column_settings.admin.sign_up": "Izen-emate berriak:",
  "notifications.column_settings.alert": "Mahaigaineko jakinarazpenak",
  "notifications.column_settings.favourite": "Gogokoak:",
  "notifications.column_settings.filter_bar.advanced": "Bistaratu kategoria guztiak",
  "notifications.column_settings.filter_bar.category": "Iragazki-barra bizkorra",
  "notifications.column_settings.follow": "Jarraitzaile berriak:",
  "notifications.column_settings.follow_request": "Jarraitzeko eskaera berriak:",
  "notifications.column_settings.group": "Taldea",
  "notifications.column_settings.mention": "Aipamenak:",
  "notifications.column_settings.poll": "Inkestaren emaitzak:",
  "notifications.column_settings.push": "Push jakinarazpenak",
  "notifications.column_settings.quote": "Aipuak:",
  "notifications.column_settings.reblog": "Bultzadak:",
  "notifications.column_settings.show": "Erakutsi zutabean",
  "notifications.column_settings.sound": "Jo soinua",
  "notifications.column_settings.status": "Bidalketa berriak:",
  "notifications.column_settings.unread_notifications.category": "Irakurri gabeko jakinarazpenak",
  "notifications.column_settings.unread_notifications.highlight": "Nabarmendu irakurri gabeko jakinarazpenak",
  "notifications.column_settings.update": "Edizioak:",
  "notifications.filter.all": "Denak",
  "notifications.filter.boosts": "Bultzadak",
  "notifications.filter.favourites": "Gogokoak",
  "notifications.filter.follows": "Jarraipenak",
  "notifications.filter.mentions": "Aipamenak",
  "notifications.filter.polls": "Inkestaren emaitza",
  "notifications.filter.statuses": "Jarraitzen duzun jendearen berriak",
  "notifications.grant_permission": "Eman baimena.",
  "notifications.group": "{count} jakinarazpen",
  "notifications.mark_as_read": "Markatu jakinarazpen guztiak irakurrita",
  "notifications.permission_denied": "Mahaigaineko jakinarazpenak ez daude erabilgarri, nabigatzaileari baimen eskaera ukatu zitzaiolako",
  "notifications.permission_denied_alert": "Mahaigaineko jakinarazpenak ezin dira gaitu, nabigatzaileari baimena ukatu zitzaiolako",
  "notifications.permission_required": "Mahaigaineko jakinarazpenak ez daude erabilgarri, horretarako behar den baimena ez delako eman.",
  "notifications.policy.accept": "Onartu",
  "notifications.policy.accept_hint": "Erakutsi jakinarazpenetan",
  "notifications.policy.drop": "Ezikusi",
  "notifications.policy.drop_hint": "Hutsera bidali, ez erakutsi inoiz gehiago",
  "notifications.policy.filter": "Iragazi",
  "notifications.policy.filter_hint": "Bidali filtratutako jakinarazpenen sarrerako ontzira",
  "notifications.policy.filter_limited_accounts_hint": "Zerbitzariaren moderatzaileek mugatuta",
  "notifications.policy.filter_limited_accounts_title": "Moderatutako kontuak",
  "notifications.policy.filter_new_accounts.hint": "Azken {days, plural, one {egunean} other {# egunetan}} sortua",
  "notifications.policy.filter_new_accounts_title": "Kontu berriak",
  "notifications.policy.filter_not_followers_hint": "{days, plural, one {Egun batez} other {# egunez}} baino gutxiago jarraitu zaituen jendea barne",
  "notifications.policy.filter_not_followers_title": "Jarraitzen ez zaituen jendea",
  "notifications.policy.filter_not_following_hint": "Eskuz onartzen dituzun arte",
  "notifications.policy.filter_not_following_title": "Jarraitzen ez duzun jendea",
  "notifications.policy.filter_private_mentions_hint": "Iragazita, baldin eta zure aipamenaren erantzuna bada edo bidaltzailea jarraitzen baduzu",
  "notifications.policy.filter_private_mentions_title": "Eskatu gabeko aipamen pribatuak",
  "notifications.policy.title": "Kudeatu honen jakinarazpenak…",
  "notifications_permission_banner.enable": "Gaitu mahaigaineko jakinarazpenak",
  "notifications_permission_banner.how_to_control": "Mastodon irekita ez dagoenean jakinarazpenak jasotzeko, gaitu mahaigaineko jakinarazpenak. Mahaigaineko jakinarazpenak ze elkarrekintzak eragingo dituzten zehazki kontrolatu dezakezu goiko {icon} botoia erabiliz, gaituta daudenean.",
  "notifications_permission_banner.title": "Ez galdu ezer inoiz",
  "onboarding.follows.back": "Atzera",
  "onboarding.follows.empty": "Zoritxarrez, ezin da emaitzik erakutsi orain. Bilaketa erabil dezakezu edo Arakatu orrian jendea bilatu jarraitzeko, edo saiatu geroago.",
  "onboarding.follows.search": "Bilatu",
  "onboarding.follows.title": "Jarraitu jendea hasteko",
  "onboarding.profile.discoverable": "Profila aurkitzeko moduan jarri",
  "onboarding.profile.discoverable_hint": "Mastodon zure profila aurkitzeko moduan duzunean, zure mezuak bilaketa-emaitzetan eta jarraipenetan ager daitezke, eta zure profila antzeko interesa duen jendeari iradoki ahal zaio.",
  "onboarding.profile.display_name": "Bistaratzeko izena",
  "onboarding.profile.display_name_hint": "Zure izena edo ezizena…",
  "onboarding.profile.note": "Biografia",
  "onboarding.profile.note_hint": "Beste pertsona batzuk @aipa ditzakezu edo #traolak erabili…",
  "onboarding.profile.title": "Profilaren konfigurazioa",
  "onboarding.profile.upload_avatar": "Igo profilaren irudia",
  "onboarding.profile.upload_header": "Igo profilaren goiburua",
  "password_confirmation.exceeds_maxlength": "Pasahitzaren berrespenak pasahitzaren gehienezko luzera gainditzen du",
  "password_confirmation.mismatching": "Pasahitzaren berrespena ez dator bat",
  "picture_in_picture.restore": "Leheneratu",
  "poll.closed": "Itxita",
  "poll.refresh": "Berritu",
  "poll.reveal": "Ikusi emaitzak",
  "poll.total_people": "{count, plural, one {pertsona #} other {# pertsona}}",
  "poll.total_votes": "{count, plural, one {boto #} other {# boto}}",
  "poll.vote": "Bozkatu",
  "poll.voted": "Erantzun honi eman diozu botoa",
  "poll.votes": "{votes, plural, one {boto #} other {# boto}}",
  "poll_button.add_poll": "Gehitu inkesta bat",
  "poll_button.remove_poll": "Kendu inkesta",
  "privacy.change": "Aldatu bidalketaren pribatutasuna",
  "privacy.direct.long": "Argitalpen honetan aipatutako denak",
  "privacy.direct.short": "Aipu pribatua",
  "privacy.private.long": "Soilik jarraitzaileak",
  "privacy.private.short": "Jarraitzaileak",
  "privacy.public.long": "Mastodonen dagoen edo ez dagoen edonor",
  "privacy.public.short": "Publikoa",
  "privacy.quote.disabled": "{visibility}, aipuak desgaituta",
  "privacy.quote.limited": "{visibility}, aipuak mugatuta",
  "privacy.unlisted.additional": "Aukera honek publiko modua bezala funtzionatzen du, baina argitalpena ez da agertuko zuzeneko jarioetan edo traoletan, \"Arakatu\" atalean edo Mastodonen bilaketan, nahiz eta kontua zabaltzeko onartu duzun.",
  "privacy.unlisted.long": "Ezkutatuta Mastodon bilaketen emaitzetatik, joeretatik, eta denbora-lerro publikoetatik",
  "privacy.unlisted.short": "Ikusgarritasun mugatua",
  "privacy_policy.last_updated": "Azkenengo eguneraketa {date}",
  "privacy_policy.title": "Pribatutasun politika",
  "quote_error.edit": "Aipuak ezin dira gehitu bidalketa bat editatzean.",
  "quote_error.poll": "Inkestak ezin dira aipatu.",
  "quote_error.private_mentions": "Aipuak ez dira onartzen aipamen pribatuetan.",
  "quote_error.quote": "Bidalketa bakoitzeko aipu bakarra onartzen da.",
  "quote_error.unauthorized": "Ez duzu baimenik bidalketa hau aipatzeko.",
  "quote_error.upload": "Aipuak ez dira onartzen multimedia eranskinekin.",
  "recommended": "Gomendatua",
  "refresh": "Berritu",
  "regeneration_indicator.please_stand_by": "Itxaron, mesedez.",
  "regeneration_indicator.preparing_your_home_feed": "Zure hasierako jarioa prestatzen…",
  "relative_time.days": "{number}e",
  "relative_time.full.days": "Duela {number, plural, one {egun #} other {# egun}}",
  "relative_time.full.hours": "Duela {number, plural, one {ordu #} other {# ordu}}",
  "relative_time.full.just_now": "oraintxe",
  "relative_time.full.minutes": "Duela {number, plural, one {minutu #} other {# minutu}}",
  "relative_time.full.seconds": "Duela {number, plural, one {segundo #} other {# segundo}}",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "orain",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "gaur",
  "remove_quote_hint.button_label": "Ulertuta",
  "remove_quote_hint.message": "{icon} aukeren menutik egin dezakezu.",
  "remove_quote_hint.title": "Aipatu dizuten bidalketa kendu nahi duzu?",
  "reply_indicator.attachments": "{count, plural, one {# eranskin} other {# eranskin}}",
  "reply_indicator.cancel": "Utzi",
  "reply_indicator.poll": "Inkesta",
  "report.block": "Blokeatu",
  "report.block_explanation": "Ez dituzu bere bidalketak ikusiko. Ezingo dituzte zure bidalketak ikusi eta ez jarraitu. Blokeatu dituzula jakin dezakete.",
  "report.categories.legal": "Juridikoa",
  "report.categories.other": "Bestelakoak",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Edukiak zerbitzariko arau bat edo gehiago urratzen ditu",
  "report.category.subtitle": "Aukeratu egokiena",
  "report.close": "Egina",
  "report.comment.title": "Beste zerbait jakin beharko genuke?",
  "report.forward": "Birbidali hona: {target}",
  "report.forward_hint": "Kontu hau beste zerbitzari batekoa da. Bidali txostenaren kopia anonimo hara ere?",
  "report.mute": "Mututu",
  "report.mute_explanation": "Ez dituzu bere bidalketak ikusiko. Zuri jarraitu eta zure bidalketak ikusteko aukera izango dute eta ezingo dute jakin mututu dituzula.",
  "report.next": "Hurrengoa",
  "report.placeholder": "Iruzkin gehigarriak",
  "report.reasons.dislike": "Ez dut gustukoa",
  "report.reasons.dislike_description": "Ikusi nahi ez dudan zerbait da",
  "report.reasons.legal": "Ilegala da",
  "report.reasons.legal_description": "Uste duzu zure herrialdeko eta zerbitzariko legedia hausten duela",
  "report.reasons.other": "Beste zerbait da",
  "report.reasons.other_description": "Arazoa ezin da beste kategorietan sailkatu",
  "report.reasons.spam": "Spama da",
  "report.reasons.spam_description": "Esteka maltzurrak, gezurrezko elkarrekintzak edo erantzun errepikakorrak",
  "report.reasons.violation": "Zerbitzariaren arauak hausten ditu",
  "report.reasons.violation_description": "Arau zehatzak urratzen dituela badakizu",
  "report.rules.subtitle": "Hautatu dagozkion guztiak",
  "report.rules.title": "Ze arau hautsi ditu?",
  "report.statuses.subtitle": "Hautatu dagozkion guztiak",
  "report.statuses.title": "Salaketa hau babesten duen bidalketarik badago?",
  "report.submit": "Bidali",
  "report.target": "{target} salatzen",
  "report.thanks.take_action": "Hemen dituzu Mastodonen ikusiko duzuna kontrolatzeko aukerak:",
  "report.thanks.take_action_actionable": "Hau berrikusten dugun bitartean, @{name} erabiltzailearen aurkako neurriak hartu ditzakezu:",
  "report.thanks.title": "Ez duzu hau ikusi nahi?",
  "report.thanks.title_actionable": "Mila esker salaketagatik, berrikusiko dugu.",
  "report.unfollow": "@{name} jarraitzeari utzi",
  "report.unfollow_explanation": "Kontu hau jarraitzen ari zara. Zure denbora-lerro nagusian bere bidalketak ez ikusteko, jarraitzeari utzi.",
  "report_notification.attached_statuses": "{count, plural, one {Bidalketa {count}} other {{count} bidalketa}} erantsita",
  "report_notification.categories.legal": "Legala",
  "report_notification.categories.legal_sentence": "eduki ilegala",
  "report_notification.categories.other": "Bestelakoak",
  "report_notification.categories.other_sentence": "bestelakoak",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spama",
  "report_notification.categories.violation": "Arau haustea",
  "report_notification.categories.violation_sentence": "arau haustea",
  "report_notification.open": "Ireki salaketa",
  "search.clear": "Garbitu bilaketa",
  "search.no_recent_searches": "Duela gutxiko bilaketarik ez",
  "search.placeholder": "Bilatu",
  "search.quick_action.account_search": "{x}-(r)ekin bat datozen profilak",
  "search.quick_action.go_to_account": "Joan {x} profilera",
  "search.quick_action.go_to_hashtag": "Joan {x} traolara",
  "search.quick_action.open_url": "Ireki URLa Mastodonen",
  "search.quick_action.status_search": "{x}-(r)ekin bat datozen argitalpenak",
  "search.search_or_paste": "Bilatu edo itsatsi URLa",
  "search_popout.full_text_search_disabled_message": "{domain}-en ez dago eskuragarri.",
  "search_popout.full_text_search_logged_out_message": "Soilik erabilgarri saioa hastean.",
  "search_popout.language_code": "ISO hizkuntza-kodea",
  "search_popout.options": "Bilaketaren aukerak",
  "search_popout.quick_actions": "Ekintza azkarrak",
  "search_popout.recent": "Duela gutxiko bilaketak",
  "search_popout.specific_date": "data jakin bat",
  "search_popout.user": "erabiltzailea",
  "search_results.accounts": "Profilak",
  "search_results.all": "Guztiak",
  "search_results.hashtags": "Traolak",
  "search_results.no_results": "Emaitzarik ez.",
  "search_results.no_search_yet": "Saiatu bilatzen bidalketak, profilak edo traolak.",
  "search_results.see_all": "Ikusi guztiak",
  "search_results.statuses": "Bidalketak",
  "search_results.title": "Bilatu \"{q}\"",
  "server_banner.about_active_users": "Azken 30 egunetan zerbitzari hau erabili duen jendea (hilabeteko erabiltzaile aktiboak)",
  "server_banner.active_users": "erabiltzaile aktibo",
  "server_banner.administered_by": "Administratzailea(k):",
  "server_banner.is_one_of_many": "{domain} fedibertsoan parte hartzeko erabil dezakezun Mastodonen zerbitzari independenteetako bat da.",
  "server_banner.server_stats": "Zerbitzariaren estatistikak:",
  "sign_in_banner.create_account": "Sortu kontua",
  "sign_in_banner.follow_anyone": "Jarraitu edonori fedibertsoan eta ikusi dena ordena kronologikoan. Algoritmorik gabe, iragarki edo titulu gezurtirik gabe.",
  "sign_in_banner.mastodon_is": "Mastodon gertatzen ari denari buruz egunean egoteko modurik onena da.",
  "sign_in_banner.sign_in": "Hasi saioa",
  "sign_in_banner.sso_redirect": "Hasi saioa edo izena eman",
  "status.admin_account": "Ireki @{name} erabiltzailearen moderazio interfazea",
  "status.admin_domain": "{domain}-(r)en moderazio-interfazea ireki",
  "status.admin_status": "Ireki bidalketa hau moderazio interfazean",
  "status.all_disabled": "Bultzadak eta aipuak desgaituta daude",
  "status.block": "Blokeatu @{name}",
  "status.bookmark": "Laster-marka",
  "status.cancel_reblog_private": "Kendu bultzada",
  "status.cannot_quote": "Ez duzu bidalketa hau aipatzeko baimenik",
  "status.cannot_reblog": "Bidalketa honi ezin zaio bultzada eman",
  "status.contains_quote": "Aipua darama",
  "status.context.loading": "Erantzun gehiago kargatzen",
  "status.context.loading_error": "Ezin erantzun berririk kargatu",
  "status.context.loading_success": "Erantzun berriak kargatuta",
  "status.context.more_replies_found": "Erantzun gehiago aurkitu dira",
  "status.context.retry": "Saiatu berriz",
  "status.context.show": "Erakutsi",
  "status.continued_thread": "Harian jarraitu zuen",
  "status.copy": "Kopiatu bidalketaren esteka",
  "status.delete": "Ezabatu",
  "status.delete.success": "Bidalketa ezabatuta",
  "status.detailed_status": "Elkarrizketaren ikuspegi xehetsua",
  "status.direct": "Aipatu pribatuki @{name}",
  "status.direct_indicator": "Aipamen pribatua",
  "status.edit": "Editatu",
  "status.edited": "Azken edizioa: {date}",
  "status.edited_x_times": "{count, plural, one {behin} other {{count} aldiz}} editatua",
  "status.embed": "Lortu txertatzeko kodea",
  "status.favourite": "Gogokoa",
  "status.favourites_count": "{count, plural, one {{counter} gogoko} other {{counter} gogoko}}",
  "status.filter": "Iragazi bidalketa hau",
  "status.history.created": "{name} erabiltzaileak sortua {date}",
  "status.history.edited": "{name} erabiltzaileak editatua {date}",
  "status.load_more": "Kargatu gehiago",
  "status.media.open": "Egin klik irekitzeko",
  "status.media.show": "Egin klik erakusteko",
  "status.media_hidden": "Multimedia ezkutatua",
  "status.mention": "Aipatu @{name}",
  "status.more": "Gehiago",
  "status.mute": "Mututu @{name}",
  "status.mute_conversation": "Mututu elkarrizketa",
  "status.open": "Hedatu bidalketa hau",
  "status.pin": "Finkatu profilean",
  "status.quote": "Aipua",
  "status.quote.cancel": "Utzi aipua",
  "status.quote_error.blocked_account_hint.title": "Bidalketa hau ezkutatuta dago @{name} blokeatu duzulako.",
  "status.quote_error.blocked_domain_hint.title": "Bidalketa hau ezkutatuta dago {domain} blokeatu duzulako.",
  "status.quote_error.filtered": "Ezkutatuta zure iragazki baten ondorioz",
  "status.quote_error.limited_account_hint.action": "Erakutsi hala ere",
  "status.quote_error.limited_account_hint.title": "{domain} zerbitzariaren moderatzaileek kontu hau ezkutatu dute.",
  "status.quote_error.muted_account_hint.title": "Bidalketa hau ezkutatuta dago @{name} mututu duzulako.",
  "status.quote_error.not_available": "Bidalketa ez dago eskuragarri",
  "status.quote_error.pending_approval": "Bidalketa zain dago",
  "status.quote_error.pending_approval_popout.body": "Mastodonen, norbaitek aipa zaitzakeen kontrola dezakezu. Bidalketa hau argitaratzeke dago jatorrizko egilearen oniritzia jaso bitartean.",
  "status.quote_error.revoked": "Egileak bidalketa kendu du",
  "status.quote_followers_only": "Bidalketa hau jarraitzaileek soilik aipatu dezakete",
  "status.quote_manual_review": "Egileak eskuz berrikusiko du",
  "status.quote_noun": "Aipua",
  "status.quote_policy_change": "Aldatu nork aipa zaitzakeen",
  "status.quote_post_author": "@{name} erabiltzailearen bidalketaren aipua",
  "status.quote_private": "Bidalketa pribatuak ezin dira aipatu",
  "status.quotes.empty": "Momentuz inork ez du bidalketa hau aipatu. Norbaitek eginez gero, hemen agertuko da.",
  "status.quotes.local_other_disclaimer": "Egileak errefusatutako aipuak ez dira erakutsiko.",
  "status.quotes.remote_other_disclaimer": "{domain} zerbitzariko aipuak baino ez daude bermatuta hemen. Egileak errefusatutako aipuak ez dira erakutsiko.",
  "status.quotes_count": "{count, plural, one {{counter} aipu} other {{counter} aipu}}",
  "status.read_more": "Irakurri gehiago",
  "status.reblog": "Bultzada",
  "status.reblog_or_quote": "Bultzatu edo aipatu",
  "status.reblog_private": "Partekatu berriz zure jarraitzaileekin",
  "status.reblogged_by": "{name}(r)en bultzada",
  "status.reblogs.empty": "Inork ez dio bultzada eman bidalketa honi oraindik. Inork egiten badu, hemen agertuko da.",
  "status.reblogs_count": "{count, plural, one {{counter} bultzaeda} other {{counter} bultzaeda}}",
  "status.redraft": "Ezabatu eta berridatzi",
  "status.remove_bookmark": "Kendu laster-marka",
  "status.remove_favourite": "Kendu gogokoetatik",
  "status.remove_quote": "Kendu",
  "status.replied_in_thread": "Harian erantzun zuen",
  "status.replied_to": "{name} erabiltzaileari erantzuna",
  "status.reply": "Erantzun",
  "status.replyAll": "Erantzun harian",
  "status.report": "Salatu @{name}",
  "status.request_quote": "Eskatu aipatzeko",
  "status.revoke_quote": "Ezabatu nire bidalketa @{name}-(r)en bidalketatik",
  "status.sensitive_warning": "Kontuz: Eduki hunkigarria",
  "status.share": "Partekatu",
  "status.show_less_all": "Erakutsi denetarik gutxiago",
  "status.show_more_all": "Erakutsi denetarik gehiago",
  "status.show_original": "Erakutsi jatorrizkoa",
  "status.title.with_attachments": "{user} erabiltzaileak {attachmentCount, plural, one {eranskin bat} other {{attachmentCount} eranskin}} argitaratu d(it)u",
  "status.translate": "Itzuli",
  "status.translated_from_with": "Itzuli {lang}(e)tik {provider} erabiliz",
  "status.uncached_media_warning": "Aurrebista ez dago erabilgarri",
  "status.unmute_conversation": "Desmututu elkarrizketa",
  "status.unpin": "Desfinkatu profiletik",
  "subscribed_languages.lead": "Hautatutako hizkuntzetako bidalketak soilik agertuko dira zure denbora-lerroetan aldaketaren ondoren. Ez baduzu bat ere aukeratzen hizkuntza guztietako bidalketak jasoko dituzu.",
  "subscribed_languages.save": "Gorde aldaketak",
  "subscribed_languages.target": "Aldatu {target}(e)n harpidetutako hizkuntzak",
  "tabs_bar.home": "Hasiera",
  "tabs_bar.menu": "Menua",
  "tabs_bar.notifications": "Jakinarazpenak",
  "tabs_bar.publish": "Bidalketa berria",
  "tabs_bar.search": "Bilatu",
  "terms_of_service.effective_as_of": "Indarrean {date}tik aurrera",
  "terms_of_service.title": "Zerbitzuaren baldintzak",
  "terms_of_service.upcoming_changes_on": "{date} datarako datozen aldaketak",
  "time_remaining.days": "{number, plural, one {egun #} other {# egun}} amaitzeko",
  "time_remaining.hours": "{number, plural, one {ordu #} other {# ordu}} amaitzeko",
  "time_remaining.minutes": "{number, plural, one {minutu #} other {# minutu}} amaitzeko",
  "time_remaining.moments": "Amaitzekotan",
  "time_remaining.seconds": "{number, plural, one {segundo #} other {# segundo}} amaitzeko",
  "trends.counter_by_accounts": "{count, plural, one {Pertsona {counter}} other {{counter} pertsona}} azken {days, plural, one {egunean} other {{days} egunetan}}",
  "trends.trending_now": "Joera orain",
  "ui.beforeunload": "Zure zirriborroa galduko da Mastodon uzten baduzu.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Arrastatu eta jaregin igotzeko",
  "upload_button.label": "Gehitu multimedia  (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "Fitxategi igoera muga gaindituta.",
  "upload_error.poll": "Ez da inkestetan fitxategiak igotzea onartzen.",
  "upload_error.quote": "Artxiboak igotzea ez da onartzen aipuekin.",
  "upload_form.drag_and_drop.instructions": "Multimedia eranskin bat aukeratzeko, sakatu espazioa edo enter. Arrastatu bitartean, erabili gezi-teklak multimedia eranskina edozein norabidetan mugitzeko. Sakatu berriz espazioa edon enter multimedia eranskina bere kokapen berrian jartzeko, edo sakatu ESC uzteko.",
  "upload_form.drag_and_drop.on_drag_cancel": "Arrastatzea bertan behera utzi da. {item} multimedia eranskina ez da mugitu.",
  "upload_form.drag_and_drop.on_drag_end": "{item} multimedia eranskina ez da mugitu.",
  "upload_form.drag_and_drop.on_drag_over": "{item} multimedia eranskina mugitu da.",
  "upload_form.drag_and_drop.on_drag_start": "{item} multimedia eranskina hautatu da.",
  "upload_form.edit": "Editatu",
  "upload_progress.label": "Igotzen...",
  "upload_progress.processing": "Prozesatzen…",
  "username.taken": "Erabiltzailea hartuta dago. Saiatu beste batekin",
  "video.close": "Itxi bideoa",
  "video.download": "Deskargatu fitxategia",
  "video.exit_fullscreen": "Irten pantaila osotik",
  "video.expand": "Hedatu bideoa",
  "video.fullscreen": "Pantaila osoa",
  "video.hide": "Ezkutatu bideoa",
  "video.mute": "Mututu",
  "video.pause": "Pausatu",
  "video.play": "Jo",
  "video.skip_backward": "Saltatu atzerantz",
  "video.skip_forward": "Jauzi aurrerantz",
  "video.unmute": "Soinua ezarri",
  "video.volume_down": "Bolumena jaitsi",
  "video.volume_up": "Bolumena Igo",
  "visibility_modal.button_title": "Ezarri ikusgarritasuna",
  "visibility_modal.direct_quote_warning.text": "Uneko ezarpenak gordez gero, txertatutako aipua lotura bilakatuko da.",
  "visibility_modal.direct_quote_warning.title": "Aipuak ezin dira sartu aipamen prbatuetan",
  "visibility_modal.header": "Ikusgarritasuna eta elkarreraginak",
  "visibility_modal.helper.direct_quoting": "Mastodonen argitaratutako aipamen pribatuak ezin dituzte beste erabiltzaileek aipatu.",
  "visibility_modal.helper.privacy_editing": "Ikusgarritasuna ezin da aldatu bidalketa argitaratu ondoren.",
  "visibility_modal.helper.privacy_private_self_quote": "Bidalketa pribatuen auto-aipuak ezin dira publiko egin.",
  "visibility_modal.helper.private_quoting": "Jarraitzaileentzat soilik sortutako bidalketak Mastodonen ezin dituzte beste batzuek aipatu.",
  "visibility_modal.helper.unlisted_quoting": "Jendeak aipatzen zaituenean, bere bidalketa ere joeren denbora-lerro publikoetatik ezkutatuko da.",
  "visibility_modal.instructions": "Kontrolatu nork izan dezakeen elkarreragina bidalketa honekin. Ezarpenak etorkizuneko bidalketa guztiei ere aplika diezazkiekezu <link>Hobespenak > Bidalketarako lehentsitakoak</link> atalera joanda.",
  "visibility_modal.privacy_label": "Ikusgarritasuna",
  "visibility_modal.quote_followers": "Jarraitzaileentzat soilik",
  "visibility_modal.quote_label": "Nork aipa dezake",
  "visibility_modal.quote_nobody": "Nik bakarrik",
  "visibility_modal.quote_public": "Edonork",
  "visibility_modal.save": "Gorde"
}
